import React from 'react'
import type { CSSProperties } from 'styled-components'

import { BadgeBase } from '../..'
import { useIntl } from 'react-intl'
import type { IDiscount } from '../types'
import { useUseCase } from '@s4l/utils/hooks/useUseCase'

import styles from './styles.module.css'
import debug from 'debug'

const log = debug('s4l:stayforlong_com:PropertiesHorizontal')

type TagOverride = { background: string; color: string }

export function DiscountPromo({
  discount,
  tagOverride,
}: Readonly<IDiscount & { tagOverride?: TagOverride }>) {
  const intl = useIntl()
  const { data: promo, loading, error } = useUseCase('GetCurrentPromoMarketingUseCase')

  if (error) {
    log('Error calling GetCurrentPromoMarketingUseCase')
  }

  const tag = tagOverride ?? promo?.tag
  if (loading) return null
  if (!tag) return null

  return (
    <BadgeBase
      testid="discount-badge-promo"
      className={styles.base}
      style={
        {
          '--badge-color': tag.color,
          '--badge-bg-color': tag.background,
        } as CSSProperties
      }
    >
      {discount && intl.formatMessage({ id: 'discount.today' }, { discount: ` -${discount}%` })}
    </BadgeBase>
  )
}
